/**
 * Nav menu toggle
 */
const navLeaveCatch = $('#nav-leave-catch');
const navToggler = $('.nav-toggler');
const header = $('.header');

navToggler.add('.skip-link-menu-toggler').on("click", function () {
	header.add('.hamburger').toggleClass('is-active');
	$('body').toggleClass('no-scroll');
	$('.main-nav').fadeToggle(150);

	if (header.hasClass('is-active')) {
		navLeaveCatch.attr('tabindex', 0);
		navToggler.attr('aria-expanded', true);
	} else {
		navLeaveCatch.attr('tabindex', -1);
		navToggler.attr('aria-expanded', false);
	}
});

navLeaveCatch.on("focus click", function () {
	navToggler.focus();
});

if ($(window).width() < 992) {
	$('.header-menu-buttons').appendTo('.main-nav .container');
}

$(window).on('resize', function () {
	if ($(window).width() < 992) {
		$('.header-menu-buttons').appendTo('.main-nav .container');
	} else {
		$('.header-menu-buttons').prependTo('.header-menu');
	}
}).trigger('resize');
